import React from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import { InvestmentTitleText } from 'src/components/Global/Text/TitleText'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
const Wrapper = styled.div`
  padding-top: 43px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  .continueButton {
    margin-top: 50px;
  }
  .top {
    margin-top: 100px;
  }
  p {
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    opacity: 0.8;
    margin-top: -15px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-top: -10px;
    }
  }
  h4 {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 24px;
    color: ${({ theme }) => theme.colors.NeutralBlack};
    opacity: 0.8;
  }
  .destination,
  .amount {
    margin-top: 30px;
  }
  .line {
    height: 3px;
    width: auto;
    background: ${({ theme }) => theme.colors.grey};
    margin: 30px -47px;
  }
  /* .css-b62m3t-container {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #858c94;
    box-sizing: border-box;
    border-radius: 8px;
    height: 60px;
  }
  .css-1s2u09g-control {
    height: 60px;
  }
  .css-14dclt2-Input {
    font-size: 14px;
    line-height: 24px;
    color: #6e7191;
    opacity: 0.8;
    padding-left: 16px;
  }
  .css-1okebmr-indicatorSeparator {
    background-color: transparent;
  }
  .css-1hb7zxy-IndicatorsContainer {
    border-bottom: 1px solid #858c94;
  }
  .css-319lph-ValueContainer {
    height: 60px;
    border-bottom: 1px solid #858c94;
  } */
  /* input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  } */
`
const Quicksave = () => {
  let location = useLocation()
  const options: any = [
    { value: 'General Savings', label: 'General Savings' },
    { value: 'TargetSavings', label: 'Target Savings' },
    { value: 'EmergencySavings', label: 'Emergency Savings' },
  ]
  // const [selectedOptions, setSelectedOptions] = useState([]);

  // const handleChange = (options:any) => {
  //     setSelectedOptions(options);
  //     console.log("Selected Options: ", selectedOptions)
  // };
  return (
    <Wrapper>
      <InvestmentTitleText>QuickSave</InvestmentTitleText>
      <p>Enter an amount, let’s help you save</p>
      <div className="destination">
        <h4>Tap here to choose destination</h4>
        <Select options={options} />
      </div>
      <div className="amount">
        <h4>Enter an amount</h4>
        <QuicksaveInput type="number" name="Amount" placeholder="e.g 3,000" />
      </div>
      <div className="top">
        <div className="line"></div>
        <Link to={`/quicksave-one`} state={{ backgroundLocation: location }}>
          <ModalButton>Continue</ModalButton>
        </Link>
      </div>
    </Wrapper>
  )
}
export { Quicksave }
